import { render, staticRenderFns } from "./VObsIcon.vue?vue&type=template&id=659075ea&scoped=true"
import script from "./VObsIcon.vue?vue&type=script&lang=js"
export * from "./VObsIcon.vue?vue&type=script&lang=js"
import style0 from "./VObsIcon.vue?vue&type=style&index=0&id=659075ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659075ea",
  null
  
)

export default component.exports